var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Router, NavigationStart } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
const description = 'Forbes CAREERは日本の未来を担うスタートアップ、隠れた名企業との出会いの場です。Forbes編集部が発掘した企業・ヒトに潜む、情熱的かつドラマティックなストーリーをお楽しみください。';
const siteUrl = 'https://forbesjapan-career.com/';
const siteName = 'Forbes CAREER (フォーブス キャリア)';
const ogpImage = '/assets/img/ogp.jpg';
export class AppComponent {
    constructor(auth, meta, title, router, db) {
        this.auth = auth;
        this.meta = meta;
        this.title = title;
        this.router = router;
        this.db = db;
    }
    loadCompany(companyId, storyTitle) {
        return __awaiter(this, void 0, void 0, function* () {
            const comRef = this.db.doc(companyId);
            try {
                const company = yield comRef.get().toPromise();
                this.title.setTitle(company.get('name') + ' - ' + storyTitle + '｜Forbes CAREER');
                this.meta.updateTag({
                    name: 'description',
                    content: company.get('name') + 'のストーリーと求人・採用情報を掲載しています。',
                });
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    loadStory(storyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const ref = this.db.doc(storyId.replace(/ry/g, 'ries'));
            try {
                const story = yield ref.get().toPromise();
                this.loadCompany(story.get('company'), story.get('title'));
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.auth.auth.setPersistence('local');
            this.router.events
                .pipe(filter((event) => {
                return event instanceof NavigationStart;
            }))
                .subscribe((event) => {
                if (event.url.startsWith('/menu')) {
                    this.meta.addTag({ name: 'robots', content: 'noindex' });
                }
                else {
                    let attributeSelector = 'name="robots"';
                    this.meta.removeTag(attributeSelector);
                }
                if (event.url.startsWith('/story') || event.url.startsWith('/jobs') || event.url.startsWith('/company')) {
                    if (event.url.startsWith('/story') &&
                        !event.url.startsWith('/story/latest') &&
                        !event.url.startsWith('/story/popular')) {
                        this.loadStory(event.url);
                    }
                    return;
                }
                this.title.setTitle(siteName);
                this.meta.updateTag({ name: 'description', content: description });
                this.meta.updateTag({ property: 'og:title', content: siteName });
                this.meta.updateTag({ property: 'og:description', content: description });
                this.meta.updateTag({ property: 'og:url', content: `${environment.baseUrl}${event.url}` });
                this.meta.updateTag({ property: 'og:image', content: `${environment.baseUrl}${ogpImage}` });
            });
        });
    }
}
